import { IconLineAndBarChart } from '@consta/icons/IconLineAndBarChart'
import { IconMapStroked } from '@consta/icons/IconMapStroked'
import { IconUpload } from '@consta/icons/IconUpload'
import {
  Icon3DCube,
  IconCartography,
  IconCorrelationScheme,
  IconCrossPlot,
  IconDataManager,
  IconGeomodule,
  IconInterpretation,
  IconStratigraphy,
  IconTable,
} from '@library/components'

import type { GeomateTabType } from './types'

export function getDisplayName(type: GeomateTabType, short = false): string {
  switch (type) {
    case 'Window3D':
      return '3D вид'
    case 'Window2D':
      return '2D вид'
    case 'Table':
      return 'Таблица'
    case 'Chart':
      return 'График'
    case 'Map':
      return 'Карта'
    case 'Interpretation':
    case 'InterpretationBrowser':
      return 'Интерпретация'
    case 'CrossPlot':
    case 'CrossPlotBrowser':
      return 'Кроссплот'
    case 'GeoModule':
      return short ? 'Геомодуль' : 'Геологическое моделирование'
    case 'CorrelationScheme':
      return short ? 'Коррсхема' : 'Корреляционная схема'
    case 'Stratigraphy':
      return short ? 'Сейсмопривязка' : 'Сейсмостратиграфическая привязка'
    case 'BulkImport':
      return 'Массовый импорт'
    case 'Cartography':
      return 'Картография'
    case 'Modeling':
      return 'Моделирование'
    case 'DataManager':
      return 'Менеджер данных'
  }
}

export const getIconByType = (type: GeomateTabType) => {
  switch (type) {
    case 'Window3D':
      return Icon3DCube
    case 'Window2D':
      return IconInterpretation
    case 'CrossPlot':
    case 'CrossPlotBrowser':
      return IconCrossPlot
    case 'GeoModule':
      return IconGeomodule
    case 'Table':
      return IconTable
    case 'Chart':
      return IconLineAndBarChart
    case 'Map':
      return IconMapStroked
    case 'Interpretation':
    case 'InterpretationBrowser':
      return IconInterpretation
    case 'CorrelationScheme':
      return IconCorrelationScheme
    case 'Stratigraphy':
      return IconStratigraphy
    case 'BulkImport':
      return IconUpload
    case 'Cartography':
      return IconCartography
    case 'Modeling':
      return Icon3DCube
    case 'DataManager':
      return IconDataManager
  }
}
